export default __webpack_public_path__ + "static/13-951cc9009b5e5a1a62665cbd2465b5b4.webp";